// Independent linear axes preserve zero-signup days and make both trends visible.
export function growthAxes(totalLabel, dailyLabel) {
  return {
    y: {
      type: "linear",
      position: "left",
      beginAtZero: true,
      title: { display: true, text: totalLabel, color: "#623ce7" },
      grid: { color: "#f1f5f9" },
      ticks: { precision: 0, color: "#64748b" },
    },
    daily: {
      type: "linear",
      position: "right",
      beginAtZero: true,
      title: { display: true, text: dailyLabel, color: "#059669" },
      grid: { drawOnChartArea: false },
      ticks: { precision: 0, color: "#059669" },
    },
  };
}
